// crewbit-admin/src/hooks/useRescheduleScheduleEntry.ts
//
// Schedule Module Phase B.1 — paired hook for `reschedule_schedule_entry` RPC
// (Migration 312 + A13 corrections in 313).
// Spec: docs/references/schedule/SCHEDULE_MODULE_WIRING_v1.md §4.5.
//
// Mirror of crewbit-mobile/hooks/useRescheduleScheduleEntry.ts. Backs admin
// drag-drop date change (WeekView), drag-drop time shift (TeamView), inline
// time edits.

import { useCallback } from 'react';
import { callScheduleRpc, type ScheduleRpcResult } from '../lib/scheduleRpc';
import type { ConflictDetail } from '../lib/errorMap';

export interface RescheduleScheduleEntryInput {
  entryId: string;
  /** ISO-8601 timestamptz. */
  newStartAt: string;
  /** ISO-8601 timestamptz. */
  newEndAt: string;
  idempotencyKey?: string;
  force?: boolean;
}

export type RescheduleScheduleEntryResult = ScheduleRpcResult<{
  success: true;
  conflicts?: ConflictDetail[];
  already_at?: boolean;
  already_rescheduled?: boolean;
}>;

export function useRescheduleScheduleEntry() {
  return useCallback(
    async (input: RescheduleScheduleEntryInput): Promise<RescheduleScheduleEntryResult> => {
      return callScheduleRpc<{
        success: true;
        conflicts?: ConflictDetail[];
        already_at?: boolean;
        already_rescheduled?: boolean;
      }>('reschedule_schedule_entry', {
        p_entry_id: input.entryId,
        p_new_start_at: input.newStartAt,
        p_new_end_at: input.newEndAt,
        p_idempotency_key: input.idempotencyKey ?? null,
        p_force: input.force ?? false,
      });
    },
    [],
  );
}
